import './LegalPages.css';

export default function GDPRPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="legal-back">← Back to Home</a>
        
        <h1>GDPR Compliance</h1>
        <p className="legal-updated">Last updated: January 2026</p>

        <section>
          <h2>Our Commitment to GDPR</h2>
          <p>
            Nexus AI Recommendations is fully committed to compliance with the General Data 
            Protection Regulation (GDPR). This page outlines how we protect the rights of EU 
            data subjects and how we handle personal data.
          </p>
        </section>

        <section>
          <h2>Data Controller and Processor</h2>
          <p>
            When you use our app, you (the merchant) act as the Data Controller for your customers' 
            data, and we act as a Data Processor on your behalf. We process data only according to 
            your instructions and applicable law.
          </p>
        </section>

        <section>
          <h2>Legal Basis for Processing</h2>
          <p>We process personal data under the following legal bases:</p>
          <ul>
            <li><strong>Contract Performance:</strong> Processing necessary to provide our services to you</li>
            <li><strong>Legitimate Interest:</strong> Improving our services and ensuring security</li>
            <li><strong>Consent:</strong> Where required, we obtain explicit consent for specific processing activities</li>
          </ul>
        </section>

        <section>
          <h2>Data Subject Rights</h2>
          <p>Under GDPR, individuals have the following rights:</p>
          <ul>
            <li><strong>Right of Access:</strong> Request a copy of personal data we hold</li>
            <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
            <li><strong>Right to Erasure:</strong> Request deletion of personal data ("right to be forgotten")</li>
            <li><strong>Right to Restriction:</strong> Request limitation of processing</li>
            <li><strong>Right to Data Portability:</strong> Receive data in a portable format</li>
            <li><strong>Right to Object:</strong> Object to processing based on legitimate interest</li>
          </ul>
          <p>
            To exercise these rights, contact us at <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>. 
            We will respond within 30 days.
          </p>
        </section>

        <section>
          <h2>Data Minimization</h2>
          <p>
            We only collect data that is necessary to provide our services. For customer behavior 
            tracking, we use anonymized session identifiers rather than personal information. We do 
            not collect or store customer names, emails, or payment details.
          </p>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>We implement appropriate technical and organizational measures including:</p>
          <ul>
            <li>Encryption of data in transit (TLS 1.3) and at rest (AES-256)</li>
            <li>Regular security assessments and penetration testing</li>
            <li>Access controls and employee training</li>
            <li>Incident response procedures</li>
          </ul>
        </section>

        <section>
          <h2>International Data Transfers</h2>
          <p>
            Our servers are located in secure data centers. When data is transferred outside the EU, 
            we ensure appropriate safeguards are in place, such as Standard Contractual Clauses (SCCs) 
            or adequacy decisions.
          </p>
        </section>

        <section>
          <h2>Data Breach Notification</h2>
          <p>
            In the event of a personal data breach, we will notify affected merchants within 72 hours 
            as required by GDPR Article 33. We will provide all necessary information to help you 
            comply with your notification obligations.
          </p>
        </section>

        <section>
          <h2>Data Processing Agreement</h2>
          <p>
            By using our app, you agree to our Data Processing Agreement (DPA), which outlines our 
            obligations as a Data Processor. For a copy of our DPA, contact us at{' '}
            <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>.
          </p>
        </section>

        <section>
          <h2>Contact Our Data Protection Team</h2>
          <p>
            For any GDPR-related inquiries:<br />
            <strong>Email:</strong> <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a><br />
            <strong>Subject Line:</strong> GDPR Request
          </p>
        </section>
      </div>
    </div>
  );
}
